const colorMap = {
    writer: 'primary',
    publisher: 'secondary',
    admin: 'tertiary',
    unknown: 'tertiary',
} as ColorGradeMap;

/**
 * Pick a color for an Avatar based on the first character of a name.
 */
export const pickColorFromRoleType = (roleType: Maybe<string>): ColorGrade => {
    if (roleType === null) {
        return 'secondary';
    }

    return colorMap?.[roleType] ?? 'tertiary';
};
